import { Component, effect, inject, input, signal } from '@angular/core';
import { VehiclesService } from '../../../vehicles.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { WebsocketService } from '../../../../../../shared/services/web-socket.service';
import {
	AppSubjectEnum,
	ModulesEnum,
	OperationalRecordDto,
} from '@splitsecondconnect/ultramarine-shared';
import { RentalAgreementLinkCardComponent } from 'app/modules/admin/rental-agreements/components/rental-agreement-link-card/rental-agreement-link-card.component';
import { SectionWrapperComponent } from 'app/shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { VehicleMaintenanceLinkCardComponent } from '../../../../vehicle-maintenances/components/vehicle-maintenance-link-card/vehicle-maintenance-link-card.component';
import { TranslocoModule } from '@ngneat/transloco';
import { LoadingSpinnerComponent } from '../../../../../../shared/components/loading-spinner/loading-spinner.component';

@Component({
	selector: 'app-vehicle-next-operation',
	templateUrl: 'vehicle-next-operation.component.html',
	imports: [
		RentalAgreementLinkCardComponent,
		VehicleMaintenanceLinkCardComponent,
		SectionWrapperComponent,
		TranslocoModule,
		LoadingSpinnerComponent,
	],
})
export class VehicleNextOperationComponent {
	vehicleId = input<number>();
	#vehicleService = inject(VehiclesService);
	#webSocket = inject(WebsocketService);
	appSubjectEnum = AppSubjectEnum;
	#unsub = new Subject();
	rentalAgreementId = signal(null);
	vehicleMaintenanceId = signal(null);
	operation = signal<OperationalRecordDto>(null);
	isLoading = signal(true);

	ngOnInit() {
		this.#webSocket
			.getRecordUpdateData(ModulesEnum.RENTAL_AGREEMENTS)
			.pipe(takeUntil(this.#unsub))
			.subscribe(() => {
				this.#getNextOperation(this.vehicleId());
			});
		this.#webSocket
			.getRecordUpdateData(ModulesEnum.VEHICLE_MAINTENANCES)
			.pipe(takeUntil(this.#unsub))
			.subscribe(() => {
				this.#getNextOperation(this.vehicleId());
			});
	}

	constructor() {
		effect(() => {
			this.operation.set(null);
			this.isLoading.set(true);
			this.#getNextOperation(this.vehicleId());
		});
	}

	#getNextOperation(vehicleId) {
		this.#vehicleService
			.getNextOperation(vehicleId)
			.pipe(finalize(() => this.isLoading.set(false)))
			.subscribe({
				next: (res) => {
					this.operation.set(res.data);
				},
			});
	}

	ngOnDestroy() {
		this.#unsub.next(null);
		this.#unsub.complete();
	}
}
